import { HttpErrorResponse } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { EMPTY, Observable, Subject } from 'rxjs';
import { CarouselDocumentsComponent } from 'src/app/shared/carousel-documents/carousel-documents.component';
import { ConfirmationComponent } from 'src/app/shared/confirmation/confirmation.component';
import {
  DataSelects,
  DetailDocument,
  DocumentCategory,
} from 'src/app/shared/interfaces/data-selects';
import { RequestInformationComponent } from 'src/app/shared/request-information/request-information.component';
import { DeleteDataService } from 'src/app/shared/services/delete-data.service';
import { GetDataService } from 'src/app/shared/services/get-data.service';
import { PostDataService } from 'src/app/shared/services/post-data.service';
import { PutDataService } from 'src/app/shared/services/put-data.service';
import { RequestFormService } from 'src/app/shared/services/request-form.service';
import { AutoUnsubscribeComponent } from 'src/app/shared/utils/auto-unsubscribe.component';

@Component({
  selector: 'app-step-documentos-principales-lto',
  templateUrl: './step-documentos-principales-lto.component.html',
  styleUrls: ['./step-documentos-principales-lto.component.scss'],
})
export class StepDocumentosPrincipalesLtoComponent
  extends AutoUnsubscribeComponent
  implements OnInit {
  @Input() dataMainDocumentsLto!: DataSelects;
  @Input() saveRequest!: Observable<boolean>;
  @Output() formValidEvent = new EventEmitter<boolean>();
  @Output() stepMainDocumentLtoSavedEvent = new EventEmitter<boolean>();

  public formStepLoadDocumentLto!: FormGroup;
  protected _onDestroy = new Subject<void>();
  public documentsCategory: DocumentCategory[] = [];
  public creditTypeUpdate!: string;
  public cameraMovil!: boolean;
  public deleteDocument!: boolean;
  public canEdit = true;
  public viewDocumentsUber!: boolean;
  private allowedFileTypes = [
    'image/png',
    'image/jpeg',
    'application/pdf',
    'application/x-compressed',
  ];
  private documentsOpenCamera = [
    'IDENTIFICACIÓN FRENTE',
    'IDENTIFICACIÓN REVERSO',
  ];
  private exceptDocument = ['COMPROBANTE DE DOMICILIO'];

  constructor(
    private requestFormService: RequestFormService,
    private getDataService: GetDataService,
    private postDataService: PostDataService,
    private putDataService: PutDataService,
    private deleteDataService: DeleteDataService,
    public dialog: MatDialog
  ) {
    super();

    if (this.requestFormService.getUpdateForm()) {
      this.viewDocumentsUber =
        this.requestFormService.getUpdateForm()?.includeUberDocumentCategory;
      this.canEdit = this.requestFormService.getUpdateForm()?.canEdit;
    } else {
      this.viewDocumentsUber =
        sessionStorage.getItem('docsUber') == 'true' ? true : false;
    }
  }

  ngOnInit(): void {
    this.cameraMovil = /Android|iPhone/i.test(navigator.userAgent);

    this.saveRequest.subscribe((value) => {
      if (value) {
        this.saveDocument();
      }
    });
  }
  ngOnChanges(changes: SimpleChanges) {

    const searchForm = this.requestFormService.getUpdateForm();
    const docTypes = searchForm ? searchForm.documents : [];

    if (!changes['dataMainDocumentsLto']?.currentValue) {
      return;
    }

    if (this.viewDocumentsUber === true) {
      this.documentsCategory =
        this.dataMainDocumentsLto.documentCategories.filter(
          (op) => op.name != 'SECUNDARIOS'
        );
    } else {
      this.documentsCategory =
        this.dataMainDocumentsLto.documentCategories.filter(
          (op) => op.name === 'PRINCIPALES'
        );
    }

    this.documentsCategory.forEach((document) => {
      document.documents = document.documents.map((d) => {
        d.canOpenCamera = this.documentsOpenCamera.includes(d.name);
        d.delete = this.exceptDocument.includes(d.name);
        d.exceptDocument = this.exceptDocument.includes(d.name);
        const doc = docTypes.find((docu) => docu.typeId == d.id);
        if (doc) {
          d.uploaded = true;
          d.fileName = doc.fileName;
          d.scanned = doc.scanned;
        }
        return d;
      });
    });
    this.checkEvent();
  }

  checkEvent() {
    this.formValidEvent.emit();
  }

  loadDocument(event: any, document: DetailDocument) {
    const fileType = event.target.files[0].type;
    const fileMimeType = event.target.files[0].size < 5000000;

    if (this.allowedFileTypes.includes(fileType) && fileMimeType) {
      const formData = new FormData();
      formData.append('file', event.target.files[0]);
      document.spinner = true;
      const postSaveDocumentLto$ = this.postDataService
        .postSaveDocumentLto(
          this.getCountry().toUpperCase(),
          this.getApplicationId(),
          document.id,
          formData
        )
        .subscribe({
          next: (resp) => {
            document.spinner = false;
            document.uploaded = true;
            document.fileName = resp.fileName;
            document.scanned = resp.scanned!;
          },
          error: (err) => {
            if (
              err.status === 400 &&
              err.error.message === "You can't make another try"
            ) {
              document.uploaded = true;
            }
          },
        });
      this.subscriptions.push(postSaveDocumentLto$);
    } else {
      this.errorFormatDialog();
    }
  }

  errorFormatDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = 'min(400px,90%)';
    dialogConfig.maxWidth = 'none';
    dialogConfig.data = {
      title: 'Error de Formato.',
      question: `Solo puede agregar documentos con los siguientes formatos: .PDF, .JPG, .PNG y con un tamaño menor a 5MB. `,
    };
    this.dialog
      .open(ConfirmationComponent, dialogConfig)
      .afterClosed()
      .subscribe(() => []);
  }

  viewDocuments(doc: DetailDocument) {
    const getViewDocumentsLto$ = this.getDataService
      .getViewDocumentsLto(
        this.getCountry().toUpperCase(),
        this.getApplicationId(),
        doc.fileName
      )
      .subscribe((resp) => {
        const fileURL = URL.createObjectURL(resp);
        window.open(fileURL);
      });
    this.subscriptions.push(getViewDocumentsLto$);
  }

  saveDocument() {
    const putUpdateRequestMainDocuments$ = this.putDataService
      .putUpdateRequestMainDocuments(
        this.getCountry().toUpperCase(),
        this.getApplicationId()
      )
      .subscribe({
        next: (resp) => {
          this.requestFormService.setDataDocumentsOCRLTO(resp);
          this.stepMainDocumentLtoSavedEvent.emit(true);
        },
        error: (err) => {
          this.openRequestInformationDialog(err);
        },
      });
    this.subscriptions.push(putUpdateRequestMainDocuments$);
  }

  openRequestInformationDialog(event: HttpErrorResponse) {
    let errorMessage = 'Ha ocurrido un error.';

    const errorCoderDocuments = `MISSING_DOCUMENTS`.match(
      event?.error.errors[0].code
    );

    const missingDocumentsMessage = event?.error.errors[0].message;
    if (errorCoderDocuments) {
      errorMessage = `Debe cargar todos los documentos obligatorios (*) requeridos para poder continuar.
      \n${missingDocumentsMessage} `;
    }

    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: 'Información de solicitud',
      question: errorMessage,
    };

    this.dialog
      .open(RequestInformationComponent, dialogConfig)
      .afterClosed()
      .subscribe(() => []);
  }

  openViewModelDocuments(doc: DetailDocument) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = 'min(400px,90%)';
    dialogConfig.maxWidth = 'none';
    dialogConfig.data = {
      documents: doc.helpImageUrl,
    };
    this.dialog
      .open(CarouselDocumentsComponent, dialogConfig)
      .afterClosed()
      .subscribe(() => []);
  }

  getApplicationId() {
    return !this.requestFormService.getUpdateForm()
      ? sessionStorage.getItem('applicationId')!
      : this.requestFormService.getUpdateForm().id;
  }

  getCountry() {
    return !this.requestFormService.getUpdateForm()
      ? sessionStorage.getItem('language')!
      : this.requestFormService.getUpdateForm().countryCode.code.toLowerCase();
  }

  confirmDeleteDocuments(doc: DetailDocument) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = 'min(400px,90%)';
    dialogConfig.maxWidth = 'none';
    dialogConfig.data = {
      title: 'Eliminar',
      question: `¿Desea eliminar el documento : ${doc.name}?`,
    };
    this.dialog
      .open(ConfirmationComponent, dialogConfig)
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          const deleteDocumentsLto$ = this.deleteDataService
            .deleteDocumentsLto(
              this.getCountry().toUpperCase(),
              this.getApplicationId(),
              doc.fileName
            )
            .subscribe({
              next: () => {
                this.successErrorDeleteDocumentDialog();
                doc.uploaded = false;
              },
              error: (err) => {
                this.successErrorDeleteDocumentDialog(err.status);
              },
            });
          this.subscriptions.push(deleteDocumentsLto$);
        }
      });
  }

  successErrorDeleteDocumentDialog(error?: number) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = 'min(400px,90%)';
    dialogConfig.maxWidth = 'none';
    dialogConfig.data = {
      title: error ? 'Error!' : 'Éxito!',
      question: error
        ? `Ha ocurrido un error, no se pudo eliminar el documento.`
        : `El documento se eliminó correctamente. `,
    };
    this.dialog
      .open(ConfirmationComponent, dialogConfig)
      .afterClosed()
      .subscribe(() => EMPTY);
  }
}
